import React from "react";
import ReactDOM from "react-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import App from "./App";
import "@zendeskgarden/css-bedrock";
import "./i18n";

ReactDOM.render(<App />,
    document.getElementById("root")
);
